import React from 'react';
import Button from "../button";
import FormResponseMessage from "../formResponseMessage";
import FormGroupSelectInput from "../formGroupSelectInput";
import CenteredDots from "../General/centeredDots";

const TransferApplicationBetweenSolicitorUsersModal = (props) => {
    return (
        <div className="row">
            <div className="col-xs-1"></div>
            <div className="col-xs-10">
                <h2 className='applicationsAndPolicies-h2'>Current Settings</h2>
                <div className="row">
                    <ul className={'unorderedListNoBulletsAndSpace'}>
                        <li>
                            {'Solicitor Firm: '}
                            <strong className={'text-strong'}>
                                {(props.SelectedApp.lawsysName?props.SelectedApp.lawsysName:'')}
                            </strong>
                        </li>
                        <li>
                            {'Solicitor User: '}
                            <strong className={'text-strong'}>
                                {(props.SelectedApp.agentName?props.SelectedApp.agentName:'')}
                            </strong>
                        </li>
                    </ul>
                </div>
                <div className="row">
					<div className="col-xs-12">
						<hr className=" applicationPolicy-hr"/>
					</div>
				</div>
                <h2 className='applicationsAndPolicies-h2'>New Settings</h2>
                <div className="row">
                    <form className="form-horizontal">
                        <FormGroupSelectInput
                            Value={props.SolicitorFirms.lawsysFirms
                                .find(
                                (e) => e.id == props.Store.solicitorFirmIdSelected
                                )?.id}
                            Label={`Solicitor Firm`}
                            LeftWrapper="col-sm-3"
                            Options={[
                                {
                                key: "",
                                value: "None",
                                },
                                ...props.SolicitorFirms.lawsysFirms.map((value) => {
                                return { key: value.id, value: value.name };
                                }),
                            ]}
                            HandleInputChange={(evt) =>
                                props.handleSolicitorFirmSelect(evt.target.value)
                            }
                            CenterWrapper="col-sm-7 formGroupSelectInput-select-wrapper"
                            RightWrapper=""
                            SelectStyle={"form-control formGroupSelectInput-select"}
                        />
                        {props.Store.solicitorFirmIdSelected !== "" ? (
                            !props.AgentsList.fetching ? (
                            <div>
                                <FormGroupSelectInput
                                Value={props.AgentsList.allSolicitorUsers.find(
                                    (a) => a.userId == props.Store.solicitorFirmUserIdSelected
                                )?.userId}
                                Label={`Solicitor User`}
                                LeftWrapper="col-sm-3"
                                Options={[
                                    {
                                    key: "",
                                    value: "None",
                                    },
                                    ...props.AgentsList.allSolicitorUsers.map(
                                    (value) => {
                                        return {
                                        key: value.userId,
                                        value: value.username,
                                        };
                                    }
                                    ),
                                ]}
                                HandleInputChange={(evt) =>
                                    props.handleSolicitorSelect(evt.target.value)
                                }
                                CenterWrapper="col-sm-7 formGroupSelectInput-select-wrapper"
                                RightWrapper=""
                                SelectStyle={
                                    "form-control formGroupSelectInput-select"
                                }
                                />
                            </div>
                            ) : (
                            <div className="col-sm-12">
                                <CenteredDots />
                            </div>
                            )
                        ) : null}
                        
					</form>
                </div>
                <div className="row">
                    {
                    props.Store.badResponseTransferApplication  && Array.isArray(props.Store.badResponseTransferApplication)  
                    ?
                        <div>
                            <FormResponseMessage
                                LeftWrapper=""
                                CenterWrapper="col-xs-12"
                                MessageStyle="formResponseMessage-reject"
                                Message={
                                    <div className="">
                                        <ul>{props.Store.badResponseTransferApplication.map(value => {
                                            return (<li key={value}>{value}</li>)
                                        })}</ul>
                                        <span>Are you sure you want to make the selected changes?</span>
                                    </div>
                                }
                            />
                            <div className="form-group col-xs-12">
                                <Button wrapper="btn-wrapper-forForms" btnType="submit"
                                        btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                        clickHandler={() => props._transferApplication(true)}
                                        label="Yes"/>
                                <Button clickHandler={() => props.TransferApplicationBetweenSolicitorUsers('badResponseTransferApplication', '')}
                                        wrapper="btn-wrapper-forForms" btnType="button"
                                        btnStyle={'btn btn-primary btn-xs sharp white'}
                                        label="No"/>
                            </div>
                        </div>
                    :
                    <div>
                        { 
                            props.Store.badResponseTransferApplication 
                            ?
                            <FormResponseMessage
                                LeftWrapper=""
                                CenterWrapper="col-xs-12"
                                MessageStyle="formResponseMessage-reject"
                                Message={props.Store.badResponseTransferApplication}
                            />
                            :
                            <div>
                            {
                                props.Store.transferringApplication ?
                                    <CenteredDots/>
                                    :
                                    <div>
                                        <Button
                                            clickHandler={() =>props._transferApplication(false)}
                                            wrapper="btn-wrapper-forForms" btnType="button"
                                            btnStyle={'btn btn-primary btn-xs sharp yellow'} label="Confirm"/>
                                        <Button
                                            clickHandler={() => props.TransferApplicationBetweenSolicitorUsers('openTransferApplicationModal', false)}
                                            wrapper="btn-wrapper-forForms" btnType="button"
                                            btnStyle={'btn btn-primary btn-xs sharp white'} label="Cancel"/>
                                    </div>
                            }
                            </div>
                        }
                    </div>
                    }
                </div>
            </div>
            <div className='col-xs-1'></div>
        </div>
    )
};

export default TransferApplicationBetweenSolicitorUsersModal;